module.exports = __webpack_public_path__ + "static/media/thumbs_up.07307848.png";